import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=6e9c2f50&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=6e9c2f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c2f50",
  null
  
)

export default component.exports